const CheckMail = {
  CHECK_MAIL_SUCCESS: 'CHECK_MAIL_SUCCESS',
  CHECK_MAIL_FAIL: 'CHECK_MAIL_FAIL',
};

export default CheckMail;
